import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UiUtil } from '../../../util/ui-util';
import { Job } from '../../../domain/job';
import { Meta, Title } from '@angular/platform-browser';
import { JobService } from '../job.service';
import { JOBS_APPLICATION_EMAIL, SITE_TITLE, SOCIAL_LINK_LINKEDIN } from '../../../shared/constants';

@Component({
  selector: 'app-job-details',
  imports: [],
  templateUrl: './job-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './job-details.component.scss'
})
export class JobDetailsComponent {
  constructor(private meta: Meta, private title: Title,
    private jobsService: JobService
  ) { }

  slug: string = "";
  job: Job = new Job()
  JOBS_APPLICATION_EMAIL: string = JOBS_APPLICATION_EMAIL
  SOCIAL_LINK_LINKEDIN: string = SOCIAL_LINK_LINKEDIN

  ngOnInit() {
    this.slug = UiUtil.getLastPartOfUrl()?.toString() || "";

    var jobs = this.jobsService.getJobs()
    for (var i = 0; i < jobs.length; i++) {
      if (this.slug == jobs[i].slug) {
        this.job = jobs[i]
        break;
      }
    }

    this.title.setTitle(SITE_TITLE + ' | ' + this.job.name);
    this.meta.updateTag({ name: 'description', content: this.job.name });
    this.meta.updateTag({ name: 'keywords', content: this.job.keywords });

  }
}
